<template>
    <div class="container">
        <div class="row">
            <heading>{{ $t('city_surcharge.menuName') }}
            </heading>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col form-group">
                                <multiselect
                                    v-model="selectedCountry"
                                    track-by="id"
                                    label="name"
                                    :options="countries"
                                    :placeholder="$t('third_party.multiselect.placeholder')"
                                    selectLabel=""
                                    selectedLabel=""
                                    deselectLabel=""
                                    @select="countryChanged"
                                >
                                    <template v-slot:noOptions>
                                        {{ $t('third_party.multiselect.noOptions') }}
                                    </template>
                                </multiselect>
                            </div>
                            <div class="col">
                                <button class="btn btn-primary float-right ml-3" @click="store">{{ $t('core.actions.save') }}</button>
                                <button class="btn btn-primary float-right" @click="addSurcharge">{{ $t('core.actions.add') }}</button>
                            </div>
                        </div>
                        <table class="table">
                            <thead>
                            <tr>
                                <td>{{ $t('city_surcharge.fields.from') }}</td>
                                <td>{{ $t('city_surcharge.fields.to') }}</td>
                                <td></td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(surcharge, index) in surcharges">
                                <td class="border-0">
                                    <input type="text" class="form-control" v-model="surcharge.from.postal_code" :placeholder="$t('city_surcharge.fields.from')">

                                </td>
                                <td class="border-0">
                                    <input type="text" class="form-control" v-model="surcharge.to.postal_code" :placeholder="$t('city_surcharge.fields.to')">

                                </td>
                                <td class="border-0">
                                    <button class="btn btn-outline-danger btn" @click="surcharges.splice(index, 1)">{{ $t('core.actions.remove') }}</button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { cloneDeep } from 'lodash'

    const emptySurcharge = {
        from: {
            postal_code: null,
        },
        to: {
            postal_code: null,
        },
    }
    export default {
        name: 'CitySurchargeCreadit',
        data: function () {
            return {
                countries: lgt.countries,
                country: lgt.country,
                selectedCountry: lgt.country,
                surcharges: lgt.surcharges,
            }
        },
        methods: {
            countryChanged (val) {
                window.location = '/city-surcharge/' + val.id
            },
            addSurcharge () {
                this.surcharges.push(cloneDeep(emptySurcharge))
            },
            store () {
                let toSubmit = this.surcharges.filter((x) => {
                    return x.from.postal_code !== null
                        && x.from.postal_code !== ''
                        && x.to.postal_code !== null
                        && x.to.postal_code !== ''
                })
                axios.post('/city-surcharge/' + this.country.id, toSubmit).then((response) => {
                    window.location = '/city-surcharge/' + this.country.id + '?success'
                })
            },
        },
        created () {
            if (this.surcharges.length === 0) {
                this.addSurcharge()
            }
        },
    }
</script>
